<section class="redirect-pending-screen">
  <div class="content-wrapper">
    <img
      class="brand-logo"
      src="assets/images/aipho-logo-white-bg.svg"
      alt="AI-PHO"
    />

    <div class="message-card">
      <img
        class="caution-icon"
        src="assets/images/caution-icon-yellow.svg"
        alt="Warning"
      />

      <h1>Oops!</h1>

      <p class="main-message">{{ mainMessage }}</p>

      <p class="sub-message">
        {{ subMessage }}
        <a target="_blank" [href]="'mailto:' + supportEmail">{{
          supportEmail
        }}</a>
        and we will assist you shortly!
      </p>
    </div>
  </div>
</section>
